import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-uiux-design',
  standalone: true,
  imports: [],
  templateUrl: './uiux-design.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './uiux-design.component.scss'
})
export class UiuxDesignComponent {

}
